import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import esignatureService from "services/esignature";

export const createSignUrlAsync = createAsyncThunk(
  "esignature/getSignUrl",
  async ({ signatureId }, { rejectWithValue }) => {
    try {
      const response = await esignatureService.createSignUrl({ signatureId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

const initialState = {
  client: null,
  signatureId: null,
  signUrl: null,
  errorMessage: null,
};

const esignatureSlice = createSlice({
  name: "esignature",
  initialState,
  reducers: {
    initializeClient: (state, action) => {
      state.client = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      /** SignUrl operations */
      .addCase(createSignUrlAsync.pending, (state) => {
        state.status = "loading";
        state.signUrl = null;
        state.error = "";
      })
      .addCase(createSignUrlAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.signUrl = action.payload.signUrl;
        state.error = "";
        state.errorMessage = action.payload.errorMessage;
      })
      .addCase(createSignUrlAsync.rejected, (state, action) => {
        state.status = "failed";
        state.signUrl = null;
        state.error = action.error;
        state.errorMessage = action.payload;
      });
  },
});

export const { initializeClient } = esignatureSlice.actions;
export default esignatureSlice.reducer;
